module.exports = __webpack_public_path__ + "img/price_fluctuation_pink.24a75496.png";